import { IconButton } from './icon-button'
import { CopyIcon } from '@/components/agent-dashboard/assets'
import useCopyToClipboard from '@/hooks/use-copy-to-clipboard.tsx';
import { cn } from '@/lib/utils';
import { CheckIcon } from 'lucide-react';

interface CopyClipboardProps {
  text?: string;
  className?: string;
  iconClassName?: string;
  icon?: React.ReactNode;
  onCopy?: () => Promise<boolean | void>;
}

/** 复制文本到剪贴板组件 */
export const CopyClipboard = ({ text, className, iconClassName, icon, onCopy }: CopyClipboardProps) => {
  const { copyToClipboard, isCopied, markCopied } = useCopyToClipboard({ duration: 1500 });

  const handleCopy = async () => {
    if (onCopy) {
      const success = await onCopy();
      if (success) {
        markCopied();
      }
      return;
    }
    if (!text) return;
    copyToClipboard(String(text));
  }

  return (
    <IconButton
      className={className}
      icon={isCopied ?
        <CheckIcon className={cn('cursor-pointer size-4 text-[rgba(102,112,133,1)]', iconClassName)} /> :
        icon || <CopyIcon className={cn('cursor-pointer', iconClassName)} />
      }
      onClick={() => handleCopy()}
    />
  )
}